<template>
    <div class="card category-card">
        <div class="category-card__img" v-if="img">
            <img :src="require(`@/assets/img/${img}`)" alt="">
        </div>
        <div class="category-card__info">
            <div class="category-card_title">
                {{ title }}
            </div>
            <ul class="category-card_list">
                <li v-for="item in items">
                    {{ item }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CategoryCard2",
        props: {
            title: {
                type: String,
                default: ''
            },
            items: {
                type: [Array],
                default: () => {}
            },
            img: String,
        }
    };
</script>

<style scoped lang="scss">
    .category-card {
        display: flex;
        /*justify-content: space-between;*/
        border-radius: 5px;
        /*height: 440px;*/
        max-width: 280px;
        width: 100%;
        box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
        margin-bottom: 32px;
        flex-shrink: 0;
        flex-direction: column;

        &__info {
            border-top: 1px solid #3FB0AB;
            display: flex;
            flex-direction: column;
            width: 100%;
            padding: 16px 16px 20px 16px;
        }
        &__img {
            height: 264px;
            padding: 10px 15px;
        }
        &_title {
            color: #3F4450;
            font-size: 18px;
            margin-bottom: 16px;
        }
        &_list {
            list-style: none;
            li {
                display: flex;
                align-items: center;
                color: #686F83;
                cursor: pointer;
                font-size: 14px;
                margin-bottom: 12px;
                &:before {
                    content: "";
                    display: inline-block;
                    background-color: #3FB0AB;
                    width: 8px;
                    height: 1px;
                    margin-right: 8px;
                }
            }
        }
    }
</style>
